import { useEffect } from 'react';

/**
 * Custom hook that provides form focus handling.
 * Provides handlers for focus, blur, change, and textarea events.
 * Scroll behaviour on navigation is handled globally by ScrollToTop.
 */
const useFormFocusHandlers = (textareaRef) => {

  // Handle focus on any form element
  const handleFocus = () => {};

  // Handle blur on any form element
  const handleBlur = () => {};

  // Standard change handler for most form elements
  const handleChange = (e, setFormData) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  // Handler for textarea changes
  const handleTextareaChange = (e, setFormData) => {
    const { value } = e.target;
    setFormData(prevState => ({ ...prevState, message: value }));
  };

  // No-op — clicks inside form containers don't need special scroll handling
  const handleFormContainerClick = () => {};

  // No-op cleanup effect
  useEffect(() => {}, []);

  return {
    handleFocus,
    handleBlur,
    handleChange: (e, setFormData) => handleChange(e, setFormData),
    handleTextareaChange: (e, setFormData) => handleTextareaChange(e, setFormData),
    handleFormContainerClick,
  };
};

export default useFormFocusHandlers;
